"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 0c6.616 0 12 5.384 12 12 0 6.617-5.384 12-12 12-6.617 0-12-5.383-12-12C0 5.384 5.383 0 12 0Zm0 1.067C5.972 1.067 1.066 5.972 1.066 12c0 6.03 4.906 10.934 10.934 10.934 6.029 0 10.934-4.904 10.934-10.934 0-6.028-4.905-10.933-10.934-10.933Zm0 16.655a1.055 1.055 0 1 1 0 2.108 1.055 1.055 0 0 1 0-2.108Zm.001-12.51a3.665 3.665 0 0 1 3.655 3.466l.005.194v.79c0 .903-.325 1.756-.919 2.426l-.154.163-1.295 1.296a2.567 2.567 0 0 0-.752 1.627l-.008.206v.79a.534.534 0 0 1-1.059.086l-.007-.086v-.79c0-.903.325-1.755.918-2.424l.154-.164 1.295-1.295a2.577 2.577 0 0 0 .753-1.628l.008-.207v-.79a2.597 2.597 0 0 0-2.594-2.594 2.597 2.597 0 0 0-2.589 2.43l-.005.164v1.043a.533.533 0 0 1-1.06.087l-.007-.087V8.872a3.665 3.665 0 0 1 3.661-3.66Z",
    clipRule: "evenodd"
  })]
});